module.exports = __webpack_public_path__ + "static/media/mq.aa15683d.webp";